// "No — don't ask me again" for the inspection-team prompt.
//
// Session-scoped on purpose. The answer means "not right now, stop nagging
// me while I work through this", not "never". Keeping it in sessionStorage
// makes a new login the natural reset without a table, a migration or an
// endpoint to forget rows nobody will ever look at.
//
// Scoped per inspection: dismissing one report says nothing about the next
// one, which the inspector may well want to join.
//
// Follows the convention set out in InspectionCommandCenter/index.js —
// sessionStorage for per-session preferences, localStorage for long-lived —
// and the array-of-keys shape of afms SafetyBanner's dismissal list. Every
// accessor is guarded: storage throws in private modes and a dismissed
// prompt is never worth breaking a page over.
const KEY = "lcp.inspection-team-prompt.dismissed";

const read = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch (_) {
    return [];
  }
};

/** Has this inspection's prompt been dismissed for the rest of this session? */
export const isTeamPromptDismissed = (inspectionNumber) => {
  if (!inspectionNumber) return false;
  return read().includes(String(inspectionNumber));
};

/** Remember "don't ask me again" for this inspection, until the next login. */
export const dismissTeamPrompt = (inspectionNumber) => {
  if (!inspectionNumber) return;
  try {
    const next = read();
    const id = String(inspectionNumber);
    if (!next.includes(id)) next.push(id);
    sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch (_) {
    // Storage unavailable — the prompt simply asks again next time, which is
    // the safer of the two failures.
  }
};

/** Wipe the list. Called on logout so the next person gets a clean slate. */
export const clearTeamPromptDismissals = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) {
    /* nothing to clear */
  }
};
